import { render } from "./ProductsList.vue?vue&type=template&id=2dc309bf&scoped=true"
import script from "./ProductsList.vue?vue&type=script&lang=js"
export * from "./ProductsList.vue?vue&type=script&lang=js"

import "./ProductsList.vue?vue&type=style&index=0&id=2dc309bf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc309bf"]])

export default __exports__